<template>
  <div class="section-layout">
    <div class="mx-0 layout-all">
      <div class="form-row">
        <div class="col-12 col-md-6">
          <div class="form-row">
            <template v-for="(section, j) in sections">
              <div :key="`${j}-section`" class="col-12 col-md-12 px-0 mb-4 layout-section" v-if="section!=='Missing Driver\'s License Number' && checkSectionVisible(group[section])">
                <div class="mr-md-4 shadow-sm pb-2 rounded">
                  <div v-if="section !== 'untitled'" class="py-2 mt-1 mb-2 pl-2 text-white rounded-top" :class="{ 'product-section-heading-alert' : checkAlertHeading(section), 'product-section-heading': !checkAlertHeading(section) }">
                    <div v-if="checkAlertHeading(section)" class="float-left yellow-alert-hopd-head">
                      <span data-v-201dd800="" class="fa-stack uniform-icon-size yellow-alert-hopd"><span data-v-201dd800="" class="fas fa-circle fa-stack-2x icon-incomplete"></span> <span data-v-201dd800="" class="fas fa-exclamation fa-stack-1x" style="color: rgb(255, 255, 255);"></span></span>
                      </div>
                      <section-heading :section="section" :pageData="pageData"></section-heading>
                  </div>

                  <div v-for="(subSection, k) in subSections" :key="`${k}-subsections`" v-if="group[section][subSection]">
                    <div v-if="subSection !== 'untitled'">
                      <div class="form-row mx-0">
                        <div class="col py-1 pl-2 my-2 ml-3 product-subsection-heading">
                          <div role="heading" aria-level="4">{{ subSection }}</div>
                        </div>
                      </div>
                    </div>
                    <div v-for="(subSubSection, l) in subSubSections" :key="`${l}-sub-subsection`" v-if="group[section][subSection][subSubSection]" :class="(subSubSection === 'untitled' ? 'col-md-12 px-0' : 'col-12 col-lg-6 px-0 mb-3')">
                      <div v-if="subSubSection !== 'untitled'">
                        <div class="form-row mx-0">
                          <div class="col py-1 pl-2 my-2 ml-3 product-subsection-heading">
                            <div role="heading" aria-level="4">{{ subSubSection }}</div>
                          </div>
                        </div>
                      </div>

                      <template v-for="(fieldData, m) in group[section][subSection][subSubSection]"
                        >
                          <div
                            :key="`${m}-div`"
                            v-if="fieldData.field_type === 'text_inline_first' ||
                              fieldData.field_type === 'radio_inline_first' ||
                              fieldData.field_type === 'checkbox_inline_first' ||
                              fieldData.field_type === 'select_inline_first'"></div>

                          <form-block
                            :key="`${m}-formblock`"
                            :formdata="fieldData"
                            :formIndex="m"
                            :class="formBlockStyles(fieldData)"></form-block>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div  class="col-12 col-md-6">
          <div class="form-row">
            <div v-if="hasFields('Missing Driver\'s License Number', pageData.fields)" class="col-12 col-md-12 px-0 mb-4 layout-section">
              <div class="shadow-sm pb-2 rounded">
                <!--SECTION HEADER w/ Icon-->
                <div class="d-table mt-1">
                  <div class="d-table-cell qrp-error-background p-2">
                    <span class="fa-stack uniform-icon-size">
                      <span class="fas fa-circle fa-stack-2x icon-incomplete" style="color:#BB0000"></span>
                      <span class="fas fa-exclamation fa-stack-1x qrp-text-white"></span>
                    </span>
                  </div>
                  <div class="d-table-cell w-100 pr-2 py-2 qrp-error-background text-dark-gray" role="alert"
                    aria-atomic="true">Missing Driver's License Number</div>
                </div>
                <div class="msdl-content px-3">
                  <span>Our reports were unable to acquire the driver’s license number for the following applicants. Branch requires this information to complete the policy and run reports.</span>
                </div>
                <div class="pl-3">
                  <template v-for="(item, key) in pageData.fields" v-if="item.section === 'Missing Driver\'s License Number' && item.visible==true">
                    <div class="py-1 pl-2 mt-1 bg-lt-blue dlv-heading" :key='`header-key-${key}`' role="heading" aria-level="3">
                    {{ item.sub_section }}</div>
                    <form-block :formdata='item' :key='`formblock-key-${key}`' class="form-group"></form-block>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import FieldDisplay from '../FieldDisplay';
import SectionHeading from '../SectionHeading';
import FormBlock from '../FormBlock';
import { layoutOptions } from '../../../mixins/layoutOptions';
import { rulesMixin } from '../../../mixins/rulesMixin';
import { pageMixin } from '../../../mixins/pageMixin';
import { layout } from '../../../mixins/layout';

export default {
  props: ['group'],
  inject: ['$validator'],
  mixins: [
    rulesMixin,
    layout,
    layoutOptions,
    pageMixin
  ],
  data() {
    return {
      sections: [],
      subSections: [],
      subSubSections: [],
      layout: null,
    };
  },
  components: {
    FieldDisplay,
    SectionHeading,
    FormBlock,
  },
  methods: {
    checkSectionVisible(groupData) {
      let sectionVisible = false;
     // console.log("groupDatagroupDatagroupDatagroupData", groupData);
       for (var skey in groupData) {
         // console.log('keykeykeykey', skey);
         // console.log(groupData[skey][skey].length, 'jjjjjjjjjjjjjjjjjjjj', groupData[skey]);
          if (groupData[skey][skey]) {
            for (let dCnt = 0; dCnt < groupData[skey][skey].length; dCnt++) {
              //console.log('kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk',groupData[skey][skey][dCnt]);
              if (groupData[skey][skey][dCnt] && groupData[skey][skey][dCnt].visible) {
                sectionVisible = true;
              }
            }
          }  

      }
      return sectionVisible;
    },
    /**
     * check if section heading need yellow alert background and icon
     */
    checkAlertHeading(section) {
      if (section.includes('Branch Quote Updat')) {
        return true;
      }
      return false;
    },
    /**
     * Remove duplicate values from an array.
     *
     * This is necessary to avoid repeating the 'untitled' value that represents
     * sections that do not have a name. Since all of the data is nested within
     * a section, a subsection, and a subsubsection, each needs a name to group
     * the fields together under their respective hierarchy. If, in the future,
     * the data is received in the tree structure it is supposed to be represented
     * as, then this and other steps are not necessary.
     */
    removeDuplicateValues(section) {
      return section.filter((item, pos, self) => self.indexOf(item) === pos);
    },
    compileSectionNames() {
      /* eslint-disable no-restricted-syntax, no-prototype-builtins */

      for (const section in this.group) {
        if (this.group.hasOwnProperty(section)) {
          if (!this.sections[section]) {
            this.sections.push(section);
          }

          for (const subSection in this.group[section]) {
            if (this.group[section].hasOwnProperty(subSection)) {
              if (!this.subSections[subSection]) {
                this.subSections.push(subSection);
              }

              for (const subSubSection in this.group[section][subSection]) {
                if (this.group[section][subSection].hasOwnProperty(subSubSection)) {
                  if (!this.subSubSections[subSubSection]) {
                    this.subSubSections.push(subSubSection);
                  }
                }
              }
            }
          }
        }
      }

      this.sections = this.removeDuplicateValues(this.sections);
      this.subSections = this.removeDuplicateValues(this.subSections);
      this.subSubSections = this.removeDuplicateValues(this.subSubSections);
    },
  },
  mounted() {
    this.compileSectionNames();
    console.log('this group in default layout', this.group);
  },
  watch: {
    pageData: function pageData() {
      this.compileSectionNames();
    },
    group: function group() {
      this.compileSectionNames();
    },
  },
};
</script>
<style>
.bg-lt-blue {
  background-color: #DCDFE7 !important;
}
.msdl-content{
  font-size:12px;
  color:#000000;
}
.dlv-heading{
  margin-bottom:12px;
}
.dlv-heading:not(:first-of-type){
  margin-top:16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/layouts/LayoutHopolicyDetails.vue?b195dc62